import { render, staticRenderFns } from "./ToHome.vue?vue&type=template&id=bf40fe54&"
import script from "./ToHome.vue?vue&type=script&lang=js&"
export * from "./ToHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports